import { render, staticRenderFns } from "./borrowDetail.vue?vue&type=template&id=97a58092&scoped=true&"
import script from "./borrowDetail.vue?vue&type=script&lang=js&"
export * from "./borrowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a58092",
  null
  
)

export default component.exports